import React from "react";
import { useI18n } from "@/contexts/I18nContext";
import LegalPage from "./LegalPage";
import { BUSINESS } from "@/lib/business";

const CONTENT = {
  ar: {
    eyebrow: "قانوني",
    title: "شروط الخدمة",
    updatedAt: "٢٤ فبراير ٢٠٢٦",
    intro:
      "مرحباً بك في DAAM. باستخدامك للموقع أو خدماتنا فإنك توافق على الالتزام بهذه الشروط. يرجى قراءتها بعناية قبل التسجيل أو الاشتراك في أي خطة مدفوعة.",
    sections: [
      { title: "١. طبيعة الخدمة",
        paragraphs: [
          "تُقدّم DAAM خدمات محتوى رقمي مدعومة بالذكاء الاصطناعي تشمل: توليد الصور، تصميم الكاروسيل متعدد الشرائح، الفيديو القصير، اقتراح المحتوى، والتحليلات الرقمية للحسابات الاجتماعية.",
          "قد تتضمّن المخرجات مواد أُنشئت باستخدام نماذج ذكاء اصطناعي من طرف ثالث. هذه المخرجات ليست مضمونة الدقة، وتحتاج مراجعتك قبل النشر.",
        ]},
      { title: "٢. الأهلية",
        paragraphs: [
          "يجب أن يكون عمرك ١٨ سنة أو أكثر. إذا كنت تُنشئ حساباً باسم مؤسسة فأنت تُقرّ بأنك مخوّل قانونياً بإلزامها بهذه الشروط.",
        ]},
      { title: "٣. الاشتراكات والتجديد",
        paragraphs: [
          "تتضمن DAAM ثلاث خطط مدفوعة: Creator وProfessional وBusiness. يبدأ اشتراكك بعد إتمام الدفع الآمن عبر مزوّد الدفع Tap Payments.",
          "التجديد تلقائي في نهاية كل دورة فوترة (شهرية أو سنوية) ما لم تقم بإلغاء التجديد قبل موعد التجديد.",
          "الخطط السنوية تستفيد من شهرين مجاناً مقارنةً بالسعر الشهري، لكن حصص الاستخدام (صور، فيديو، محادثة) تُحسب وتُعاد إلى القيمة الأصلية مع بداية كل دورة شهرية داخل الاشتراك السنوي.",
          "لا يتم تحويل الحصص غير المستخدمة إلى الشهر التالي.",
        ]},
      { title: "٤. الفترة التجريبية (٧ أيام)",
        paragraphs: [
          "قد نُوفّر فترة تجريبية مدتها ٧ أيام. تتطلّب الفترة التجريبية إدخال بطاقة دفع صالحة ويتم تفويض مبلغ رمزي (١ ريال سعودي) للتحقق من البطاقة عبر Tap Payments، دون خصم فعلي كامل.",
          "ينتقل الاشتراك تلقائياً إلى الحالة النشطة عند انتهاء الفترة التجريبية ما لم يتم الإلغاء قبل ذلك.",
          "الحصص المُستخدمة خلال الفترة التجريبية غير قابلة للاسترداد أو التحويل حتى إذا تم الإلغاء لاحقاً.",
        ]},
      { title: "٥. الاستخدام المسموح والاستخدام المحظور",
        paragraphs: ["يُسمح باستخدام DAAM لإدارة الحضور الرقمي المشروع لعملك أو مؤسستك. تشمل الاستخدامات المحظورة:"],
        list: [
          "توليد محتوى غير قانوني أو يخالف الأنظمة المحلية أو الدولية.",
          "انتحال شخصية أفراد أو علامات تجارية أو جهات حكومية.",
          "انتهاك حقوق الملكية الفكرية أو حقوق النشر لأي طرف ثالث.",
          "نشر محتوى مسيء أو تمييزي أو محرّض على العنف أو الكراهية.",
          "استخدام الخدمة لإرسال بريد عشوائي أو تصيّد احتيالي.",
          "الوصول غير المصرّح به إلى أنظمة DAAM أو حسابات مستخدمين آخرين.",
          "مشاركة بيانات الحساب مع أطراف خارج المؤسسة المشتركة، أو تقاسم حساب واحد بين عدة أشخاص.",
          "الهندسة العكسية أو محاولة كشف الشيفرة المصدرية للمنصة.",
        ]},
      { title: "٦. مسؤوليات المستخدم عن المحتوى المُولَّد",
        paragraphs: [
          "تحتفظ بجميع حقوق الملكية الفكرية للمحتوى الذي ترفعه، وتحصل على ترخيص استخدام تجاري كامل للمخرجات المُولَّدة من DAAM ضمن حدود اشتراكك.",
          "مخرجات الذكاء الاصطناعي قد تحتوي على أخطاء واقعية أو صياغية، وأنت المسؤول الوحيد عن مراجعتها والتأكد من دقتها ومطابقتها للأنظمة قبل نشرها.",
        ]},
      { title: "٧. الدفع والفشل في الدفع",
        paragraphs: [
          "يُعالَج الدفع بالكامل عبر Tap Payments. لا نُخزّن بيانات البطاقة الكاملة على خوادمنا.",
          "في حال فشل التجديد بسبب رفض البطاقة، سنُحاول التجديد آلياً مرتين إضافيتين خلال ٤٨ ساعة. إذا استمرّ الفشل يُعلّق وصولك إلى الميزات المدفوعة حتى تحديث وسيلة الدفع.",
        ]},
      { title: "٨. تعليق وإنهاء الحساب",
        paragraphs: [
          "يحق لـ DAAM تعليق أو إنهاء حسابك في الحالات التالية:",
        ],
        list: [
          "انتهاك أيّ من الاستخدامات المحظورة أعلاه.",
          "شبهة استخدام احتيالي أو مشاركة الحساب.",
          "طلب رسمي من الجهات المختصة.",
          "فشل الدفع لأكثر من ١٤ يوماً دون معالجة.",
        ]},
      { title: "٩. حدود المسؤولية",
        paragraphs: [
          "تُقدّم الخدمة \"كما هي\" و\"كما تتوفر\". لا نضمن أن الخدمة ستكون خالية من الأخطاء أو الانقطاعات في جميع الأوقات.",
          "إلى أقصى حدّ يسمح به القانون، لن تتحمل DAAM أي مسؤولية عن أضرار غير مباشرة أو تبعية. المسؤولية القصوى في أي نزاع لا تتجاوز المبلغ المدفوع خلال آخر اثني عشر شهراً.",
        ]},
      { title: "١٠. القانون الحاكم",
        paragraphs: [
          "تخضع هذه الشروط لقوانين المملكة العربية السعودية. أي نزاع ناشئ عنها يُحلّ ودّياً أولاً، وإلا فأمام المحاكم المختصة في مدينة الرياض.",
        ]},
      { title: "١١. التواصل معنا",
        paragraphs: [`للاستفسارات القانونية: ${BUSINESS.email_legal}`,
                     `الدعم العام: ${BUSINESS.email_support}`,
                     `العنوان: ${BUSINESS.address_ar}`]},
    ],
  },
  en: {
    eyebrow: "Legal",
    title: "Terms of Service",
    updatedAt: "February 24, 2026",
    intro:
      "Welcome to DAAM. By using our website or services you agree to be bound by these terms. Please read them carefully before registering or subscribing to any paid plan.",
    sections: [
      { title: "1. Nature of the service",
        paragraphs: [
          "DAAM provides AI-assisted digital content services including image generation, multi-slide carousel design, short-form video, content suggestions and social-account analytics.",
          "Some outputs are generated using third-party AI models. Such outputs are not guaranteed to be accurate and require your review before publication.",
        ]},
      { title: "2. Eligibility",
        paragraphs: [
          "You must be 18 or older. If you register on behalf of an organisation you represent that you are legally authorised to bind that organisation to these terms.",
        ]},
      { title: "3. Subscriptions & renewal",
        paragraphs: [
          "DAAM offers three paid plans: Creator, Professional and Business. Your subscription starts after secure payment via Tap Payments.",
          "Renewal is automatic at the end of each billing cycle (monthly or annual) unless you cancel renewal before the renewal date.",
          "Annual plans include two months free versus the monthly price. Usage allowances (images, video seconds, chat, etc.) reset at the start of each monthly cycle inside the annual subscription.",
          "Unused allowances do not roll over into the next month.",
        ]},
      { title: "4. Free trial (7 days)",
        paragraphs: [
          "We may offer a 7-day free trial. The trial requires a valid payment card and Tap Payments authorises a nominal amount (1 SAR) to verify the card, without a full charge.",
          "The subscription automatically transitions to active at the end of the trial unless cancelled beforehand.",
          "Trial usage is non-refundable and non-transferable even if cancelled later.",
        ]},
      { title: "5. Permitted & prohibited use",
        paragraphs: ["DAAM is provided for legitimate commercial use to manage the digital presence of your business or organisation. Prohibited uses include:"],
        list: [
          "Generating illegal content or content that violates local or international regulations.",
          "Impersonation of individuals, brands or government entities.",
          "Infringement of any third party's intellectual-property or copyright.",
          "Publishing offensive, discriminatory, violent or hate content.",
          "Using the service to send spam or phishing messages.",
          "Unauthorised access to DAAM's systems or to other users' accounts.",
          "Sharing account credentials with third parties outside your subscribing organisation, or sharing a single seat between multiple people.",
          "Reverse-engineering or otherwise attempting to expose the platform's source code.",
        ]},
      { title: "6. Your responsibility for generated content",
        paragraphs: [
          "You retain all IP rights in the content you upload, and you receive a full commercial-use licence to the outputs generated by DAAM within the limits of your subscription.",
          "AI outputs may contain factual or stylistic errors. You are solely responsible for reviewing, approving and legally using each output before publishing it.",
        ]},
      { title: "7. Payment & payment failure",
        paragraphs: [
          "Payment is processed exclusively via Tap Payments. We do not store full card data on our servers.",
          "If renewal fails because the card is declined, we will automatically retry twice more within 48 hours. If the failure persists, your access to paid features is suspended until the payment method is updated.",
        ]},
      { title: "8. Suspension & termination",
        paragraphs: ["DAAM may suspend or terminate your account in the following cases:"],
        list: [
          "Violation of any prohibited use above.",
          "Suspicion of fraudulent use or account sharing.",
          "Formal request from a competent authority.",
          "Payment failure unresolved for more than 14 days.",
        ]},
      { title: "9. Limitation of liability",
        paragraphs: [
          "The service is provided \"as is\" and \"as available\". We do not guarantee it will be error-free or uninterrupted at all times.",
          "To the maximum extent permitted by law, DAAM shall not be liable for any indirect or consequential damages. Total liability in any dispute shall not exceed the amount paid over the preceding twelve months.",
        ]},
      { title: "10. Governing law",
        paragraphs: [
          "These terms are governed by the laws of the Kingdom of Saudi Arabia. Any dispute will first be resolved amicably; failing that, before the competent courts of the city of Riyadh.",
        ]},
      { title: "11. Contact us",
        paragraphs: [`Legal enquiries: ${BUSINESS.email_legal}`,
                     `General support: ${BUSINESS.email_support}`,
                     `Address: ${BUSINESS.address}`]},
    ],
  },
};

export default function TermsPage() {
  const { lang } = useI18n();
  const c = CONTENT[lang] || CONTENT.en;
  return (
    <LegalPage testId="terms-page" eyebrow={c.eyebrow} title={c.title}
      updatedAt={c.updatedAt} intro={c.intro} sections={c.sections} />
  );
}
